import * as flexpolyline from '@here/flexpolyline';

const POLYLINE_CACHE = {};

export function decode(encodedPolyline) {
  if (POLYLINE_CACHE[encodedPolyline]) {
    return POLYLINE_CACHE[encodedPolyline];
  }
  const decodedPolyline = flexpolyline.decode(encodedPolyline).polyline;
  POLYLINE_CACHE[encodedPolyline] = decodedPolyline;
  return decodedPolyline;
}

export function encode(polyline) {
  const encodedPolyline = flexpolyline.encode({polyline});
  return encodedPolyline;
}
